export const FEATURES = Object.freeze({
  CROP_AND_ZOOM: 'crop',
  UPLOAD: 'upload',
  URL: 'url',
  UNSPLASH: 'unsplash',
  ZOOM: 'zoom',
});

export const UPLOAD_STEPS = Object.freeze({
  UPLOAD: 'upload',
  PREVIEW: 'preview',
});

export const ACCEPT_IMAGES = [
  'image/gif',
  'image/png',
  'image/jpeg',
  'image/webp',
];
